import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const serviceTypeApi = createApi({
  reducerPath: 'serviceTypeApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/service_types' }),
  endpoints: (builder) => ({
    getServiceTypes: builder.query({
      query: () => ({ url: '' }),
      transformResponse: (response) => response.service_types
    })
  })
})

const {
  useGetServiceTypesQuery
} = serviceTypeApi

export {
  serviceTypeApi,
  useGetServiceTypesQuery
}
